<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formSuspension">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" (onClick)="goToBack($event)" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>

          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Imprimir'" [severity]="'contrast'" [icon]="'pi pi-print'"
              (onClick)="printPage()"></app-custom-button>
            <app-custom-button [title]="'Eliminar'" [severity]="'contrast'" [icon]="'pi pi-trash'"
              (onClick)="deleteSuspension()"></app-custom-button>
            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="suspensionContract.userNameCreate"
              [createDate]="suspensionContract.createDate" [userNameUpdate]="suspensionContract.userNameUpdate"
              [updateDate]="suspensionContract.updateDate"
              [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
        <div class="row d-flex justify-content-between">
          <div class="col-lg-7 col-12">
            <div class="row">
              <div class="col-lg-4 col-md-6 col-sm-7 col-12">
                <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                  [required]="true" [recovery]="true" (onChangeSelect)="changeBranch($event)"></app-custom-select>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-2 col-6">
                <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                  [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-3 col-6">
                <app-custom-datepicker formControlName="dateSuspension" [labelText]="'Fecha'" [required]="true"
                  (onChangeDate)="onChangeDateSuspension()">
                </app-custom-datepicker>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-2 col-4">
                <app-custom-input-number formControlName="days" [labelText]="'Días'" (onChangeNumber)="onChangeDays()">
                </app-custom-input-number>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-2 col-4  d-flex align-items-end">
                <app-custom-chip *ngIf="suspensionContract.maintenanceOrderId" class="me-1"
                  [link]="['/maintenance-order/register', suspensionContract.maintenanceOrderId]"
                  tooltip="Ver orden de mantenimiento" [label]="'Orden Mtto.: ' + maintenanceOrderConsecutive" />
              </div>
              <div class="col-lg-6 col-md-6 col-sm-10 col-12">
                <app-custom-autocomplete formControlName="clientId" [labelText]="'Cliente'" [list]="listClients"
                  [required]="true" [class]="clientStateId !== stateClientOpen ? 'state-inactive' : ''"
                  (onChangeSelect)="getClient($event)">
                </app-custom-autocomplete>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                <app-custom-autocomplete formControlName="costCenterId" [labelText]="'C.Costos'"
                  [list]="filteredCostCenters" [required]="true" [class]="constructionSiteStateId != constructionSiteStateOpen
                    ? 'state-inactive' : ''" (onChangeSelect)="getCostCenter($event, false)">
                </app-custom-autocomplete>
              </div>
            </div>
          </div>
          <div class="col-lg-5 ps-lg-5 col-12">
            <div class="row">
              <div class="col-lg-3 col-md-2 col-sm-3 col-6">
                <app-custom-tag [label]="'Estado'" [severity]="severityState"
                  [value]="suspensionStateString"></app-custom-tag>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-6 d-flex align-items-end gap-1">
                <app-custom-button [title]="titleStateSuspension" [icon]="iconStateSuspension"
                  (onClick)="changeStateSuspension()"></app-custom-button>
                <app-custom-button [title]="'Anular suspensión'" [icon]="'pi pi-ban'" [severity]="'warn'"
                  (onClick)="annulSuspension()"></app-custom-button>
                <app-custom-checkbox formControlName="swBlock" class="mt-1" [labelText]="'Bloq.'"
                  (onChangeCheckBox)="blockSuspension($event)"></app-custom-checkbox>
              </div>

              <div class="col-lg-6 col-md-6 col-sm-6 col-12 d-flex align-items-end gap-1 mt-3 mb-1">
                <app-custom-chip class="ms-2 me-1" [label]="'Corte: ' + invoicingCutoffCode"
                  [link]="['/invoicing-cutoff/register', suspensionContract.invoicingCutoffId]"
                  tooltip="Ver corte de facturación" />

                <app-custom-chip class="me-1" [ngClass]="statePeriod ? '' : 'text-danger'"
                  [label]="'Periodo: ' + dataPeriod" />
              </div>

              <div class="col-lg-12 col-md-10 col-sm-12 col-12">
                <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [rows]="1"
                  [maxLength]="250" (onChangeText)="onChangeObservation()">
                </app-custom-textarea>
              </div>
              <div class="col-lg-12 col-12 d-flex justify-content-end align-items-end mt-2">
                <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [disabled]="disabledForm"
                  [variant]="undefined" (onClick)="send()">
                </app-custom-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 container-style mt-2">
    <app-suspension-detail [suspensionModel]="suspensionContract" [disabledDetail]="disabledDetail"
      [disabledActions]="disabledActions" (emitQuantityDetails)="quantityDetails = $event">
    </app-suspension-detail>
  </div>
</section>

<app-print-suspension id="print-suspension" [companyId]="companyId" [reloadPrint]="reloadPrint"
  [suspensionPrintModel]="suspensionPrintModel" [focusText]="false" [editFormat]="false"
  (finishLoadingPrint)="finishLoading($event)">
</app-print-suspension>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>